<div class="page-header">
  <div class="page-header-title" [class.xlarge-title]="titleSize === 'xlarge'">
    <ui-button
      *ngIf="showBackButton"
      type="secondary"
      icon="arrow-left"
      (click)="onBackButtonClick()"
    ></ui-button>
    <ui-svg-icon
      *ngIf="icon"
      [svgIcon]="icon"
      [size]="titleSize"
      class="page-header-title-icon"
    ></ui-svg-icon>
    <nav class="breadcrumbs" *ngIf="breadcrumbs.length > 0">
      <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
        <ng-container *ngIf="crumb.link">
          <a [routerLink]="crumb.link">{{ crumb.label }}</a>
        </ng-container>
        <ng-container *ngIf="!crumb.link">
          <span class="current">{{ crumb.label }}</span>
        </ng-container>
        <div class="divider">
          <ui-svg-icon svgIcon="chevron-right" size="small"></ui-svg-icon>
        </div>
      </ng-container>
    </nav>
    <h1 class="header-title">{{ title }}</h1>
    <span *ngIf="titleTag" class="{{ titleTagType }}--tag">{{ titleTag }}</span>
  </div>
  <div class="actions">
    <ng-content></ng-content>
  </div>
</div>
